import { SVGPureIcon } from '@/ui';
import { observer } from 'mobx-react-lite';
import React from 'react';
import FileSaver from "file-saver"
import FoldBtn from '@/ui/fold-btn';
import chatStoreManager from '@/store/chat/manager';
import Other from '@/common/helper/other';
import copy from 'copy-to-clipboard';
import "./index.scss"
import {
  TransformWrapper,
  TransformComponent
} from "react-zoom-pan-pinch";

const GenerateImg = observer(({ closeCb=()=>{}, img, blob=null }) => {
  return (
    <div
      className="fixed w-100vw h-100vh left-0 top-0 bg-[#00000050] z-200 flex flex-col items-center justify-center"
    >
      <div className="w-640px h-0 flex-grow flex flex-col rounded-24px bg-white px-24px pt-30px pb-20px relative my-80px">
        <SVGPureIcon 
          name='chat_share_img_close' 
          className='size-10px absolute top-30px right-30px cursor-pointer text-[rgba(0,0,0,0.5)] hover:text-[rgba(0,0,0,0.8)]' 
          onClick={() => {
            closeCb && closeCb()
          }}
        />
        <div className='font-bold text-24px leading-34px text-black'>生成图片</div>
        <div className='h-0 flex-grow w-full bg-[rgba(0,0,0,0.06)] rounded-20px mt-17px overflow-hidden nw-no-scroll chat-share-img-preview'>
          <TransformWrapper
            wheel={{
              step: 0.5
            }}
          >
            <TransformComponent>
              <img src={img} className='h-full' />
            </TransformComponent>
          </TransformWrapper>
        </div>
        <div className='mt-19px h-40px flex justify-end'>
          <FoldBtn 
            iconName="chat_share_img_download"
            text="下载图片"
            className="mr-12px border-0px bg-[rgba(0,0,0,0.06)] hover:bg-[rgba(0,0,0,0.09)] !rounded-12px !h-40px !px-20px"
            iconClassName="!size-20px !mr-6px"
            textClassName="!text-16px font-bold"
            onClick={() => {
              FileSaver.saveAs(img, chatStoreManager.current?.historyData?.title + ".png")
            }}
          />
          <FoldBtn 
            iconName="chat_share_img_copy"
            text="复制图片"
            textClassName="text-white !text-16px font-bold"
            iconClassName="text-white !size-20px !mr-6px"
            className="mr-0px border-0px bg-[#000000] !rounded-12px hover:bg-[#333333] !h-40px !px-20px"
            onClick={() => {
              blob && navigator?.clipboard?.write([
                new ClipboardItem({
                    [blob.type]: blob
                })
              ]).then(() => {
                Other.toast('复制成功', "success");
              }).catch(() => {
                Other.toast('复制失败', "warning");
              })
            }}
          />
        </div>
      </div>
    </div>
  );
});

export default GenerateImg;